import React from 'react';

const Skill = props => {
    return (
        <div className='skill-section'>
            <i className={props.iconClass}></i>
            {/* <h3>{props.skillName}</h3> */}
            <ul className='skills-list'>
                {props.skills.map(skill => {
                    return <li key={skill} className='individual-skill'>{skill}</li>
                })}
            </ul>
        </div>
    )
}

export default Skill;